<template>
  <div class="module-manage">
    <el-card>
      <template #header>
        <div class="card-header">
          <span>首页模块管理</span>
          <el-button type="primary" size="small" @click="handleSave">保存排序</el-button>
        </div>
      </template>
      <el-table :data="modules" row-key="id" border>
        <el-table-column prop="id" label="ID" width="60" />
        <el-table-column prop="module_key" label="模块标识" width="120" />
        <el-table-column prop="module_name" label="模块名称" width="120" />
        <el-table-column prop="module_icon" label="图标" width="80" />
        <el-table-column label="排序" width="100">
          <template #default="{ row }">
            <el-input-number v-model="row.sort" :min="0" :max="99" size="small" controls-position="right" />
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template #default="{ row }">
            <el-switch v-model="row.status" :active-value="1" :inactive-value="0" />
          </template>
        </el-table-column>
        <el-table-column prop="updated_at" label="更新时间" width="170" />
      </el-table>
    </el-card>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import request from '@/utils/request'
import { ElMessage } from 'element-plus'

const modules = ref([])

const loadModules = async () => {
  try {
    const res = await request.get('/api/admin/home-modules')
    modules.value = res.data || []
  } catch (e) {
    ElMessage.error('加载模块失败')
  }
}

const handleSave = async () => {
  try {
    const payload = modules.value.map(m => ({
      id: m.id,
      sort: m.sort,
      status: m.status,
      params_json: m.params_json || null
    }))
    await request.put('/api/admin/home-modules', { modules: payload })
    ElMessage.success('保存成功')
    loadModules()
  } catch (e) {
    ElMessage.error('保存失败')
  }
}

onMounted(() => {
  loadModules()
})
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
